export default {
    userBaseData: 'Daten',
    userSignature: 'Signatur',
    userOrganisations: 'Organisationen',
    userActivities: 'Historie',
    userCommunications: 'Kommunikation'
}